/**
 * The questions the landing page answers, written once.
 *
 * Both the section a visitor reads and the FAQPage structured data a crawler
 * reads are built from this list. Google requires the two to say the same
 * thing, and the way that rule normally gets broken is a copy edit landing in
 * the markup and not the schema — so there is only one place to edit.
 *
 * Every answer here is a claim the product makes on its own landing page. Keep
 * it that way: an FAQ is the easiest place to promise something the app does
 * not do.
 */
export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ: FaqItem[] = [
  {
    question: 'Does my audience need an app?',
    answer:
      'No. Voting happens in whatever browser is already on the phone. There is nothing to install, no account to make, and nothing to refresh once someone has joined.',
  },
  {
    question: 'Is voting anonymous?',
    answer:
      'Yes, anonymously by default. Answering a poll asks for no name, email address, phone number or location, so the room can say what it actually thinks.',
  },
  {
    question: 'How do people join a poll?',
    answer:
      'With six characters. The code goes up on the big screen alongside its join link and a QR code, and everyone watching is one tap from voting.',
  },
  {
    question: 'How quickly do results appear on screen?',
    answer:
      'Every vote reaches the big screen in under two seconds. The screen is pushed to rather than polled, so nobody has to refresh anything.',
  },
  {
    question: 'Can I put my own branding on it?',
    answer:
      'Yes. Your colours and logo travel to the projector and to every phone in the room, so a poll looks like it belongs to your event rather than to us.',
  },
  {
    // Deliberately not the same sentence as the closing section, which already
    // names the free plan's ceiling. Repeating it verbatim would put the same
    // line on the page twice and say nothing new. The numbers here are the
    // ones docs/GTM.md decided and Terms §8 states — change them together.
    question: 'What does FloorPoll cost?',
    answer:
      'Nothing to run a poll for up to 100 people, and the count starts again at your next presentation. Marquee is $144 a year or $15 a month and removes the audience limit entirely; an Event Pass is $39 for 30 days without a subscription. Your audience never pays either way: answering a poll asks nobody in the room for an account or a card.',
  },
];
